export default __webpack_public_path__ + "static/media/factor-.2100862a.jpg";